import Generated from './Generated';
import Published from './Published';

const History = () => {
  return (
    <div
      data-testid={'test-history-container'}
      className="flex h-full w-full flex-col gap-2 md:flex-row"
    >
      {/* BOX 1 */}
      <div className="flex h-full w-full md:w-1/2">
        <Generated />
      </div>

      {/* BOX 2 */}
      <div className="flex h-full w-full md:w-1/2">
        <Published />
      </div>
    </div>
  );
};

export default History;
